import styled from "styled-components";

export const StyledPasswordRequirement = styled.div`
  align-items: center;
  display: flex;
  font-size: 14px;
  gap: 12px;
`;

export const StyledPasswordRequirements = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px 10px;
`;

export const StyledBold = styled.span`
  font-weight: 700;
`;
